import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

export default function AdminSettings() {
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(''); const [err, setErr] = useState('');

  useEffect(() => { api.get('/settings').then(r => setRows(r.data.settings||[])); }, []);

  const update = (k, v) => setRows(rows.map(r => r.key === k ? { ...r, value: v } : r));

  const save = async () => {
    setSaving(true); setMsg(''); setErr('');
    try {
      const payload = Object.fromEntries(rows.map(r => [r.key, r.value]));
      await api.put('/admin/settings', payload);
      setMsg('Saved');
    } catch (e) { setErr(apiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings">
      <h2 className="mb-3">Settings</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card">
        {rows.map(r => (
          <div key={r.key} className="mb-2">
            <label className="form-label">{r.key}</label>
            <input className="form-control" value={r.value||''} onChange={e=>update(r.key, e.target.value)} data-testid={`setting-${r.key}`} />
          </div>
        ))}
        <button className="btn-ap mt-2" onClick={save} disabled={saving} data-testid="save-settings">{saving ? 'Saving…' : 'Save settings'}</button>
      </div>
    </div>
  );
}
